import ajax from "@/lib/ajax";
import i18n from "@/i18n";
import { formatUnixTime } from "@/lib/format/time";
import store from "@/store";

// 将 ajax 调用的返回中 list 转为 map
async function getMap(p) {
    const { list } = await p;
    const map = {};
    list.forEach(({ id, name }) => {
        map[id] = name;
    });
    return map;
}

// action 转为后台的值
const actionMap = {
    todo: 0,
    done: 1,
    wait: 2,
    all: 3,
    auto: 4
};

export async function list(query = {}) {
    const statusMap = {
        0: i18n.t("ticket.status_0"), // 待分配",
        1: i18n.t("ticket.status_1"), // 待处理",
        2: i18n.t("ticket.status_2") // 已处理"
    };

    const resultMap = {
        5: i18n.t("ticket.result_5"), // "未解决",
        6: i18n.t("ticket.result_6"), // "已解决",
        7: i18n.t("ticket.result_7") // "无需解决"
    };

    const channelMap = {
        h5_block: i18n.t("zhiji.channel.H5Scenes"), // "安全助手/封号弹窗",
        h5_safety: i18n.t("zhiji.channel.H5Site"), // "安全助手/安全站",
        mobile: "Mobile", // "内容助手/Mobile"
        lite: "Lite", // "内容助手/Lite"
        sdk: i18n.t("zhiji.channel.SDKSet"), // "基础服务/SDK(设置)"
        sdk_login: i18n.t("zhiji.channel.SDKLogin"), // "基础服务/SDK(登录界面)"
        m_guest: i18n.t("zhiji.channel.m_guest"), // "基础服务/M(游客)"
        m_setting: i18n.t("zhiji.channel.m_setting"), // "基础服务/M(设置)"
        inner: i18n.t("zhiji.channel.Inner"), // "新建"
        svip: i18n.t("zhiji.channel.Svip"), // "管家页面"
        svip_data: i18n.t("zhiji.channel.svipData"), // "超R数据"
        Unknown: i18n.t("ticket.channel_0") // "未知"
    };

    // 超R身份
    const svipMap = {
        0: i18n.t("ticket.component.svip.svip"), //未知
        10: "", //普通(不显示)
        11: i18n.t("ticket.component.svip.svip1"), //大R
        12: i18n.t("ticket.component.svip.svip2"), //超R
        13: i18n.t("ticket.component.svip.svip3") //顶R
    };
    query = getQuestionListParams(query);

    const { action = "all" } = query;
    const result = await ajax.get("ticket/list", { ...query, action: actionMap[action] });

    if (query.export == 1) {
        return {
            download: result.download
        };
    }

    const { list } = result;
    let ids = [];

    list.forEach(({ id, creater_id, remark }) => {
        ids.push(id);
        ids.push(creater_id);

        remark &&
            remark.forEach(({ agent_id }) => {
                ids.push(agent_id);
            });
    });

    ids = Array.from(new Set(ids.map(({ id } = {}) => id).filter(x => x)));

    const [typeMap, agentMap] = await Promise.all([getMap(listType()), getMap(listAgent({ ids }))]);
    return {
        ...result,
        list: list.map(one => {
            return {
                ...one,
                agent_name: agentMap[one.agent_id],
                type_name: typeMap[one.type_id],
                channel_name: channelMap[one.channel],
                svip_name: svipMap[one.svip_level],
                creater_name: agentMap[one.creater_id],
                status_name: statusMap[one.status],
                result_name: resultMap[one.result],
                remark: one.remark
                    ? one.remark.map(value => {
                          return {
                              ...value,
                              agent_name: agentMap[value.agent_id]
                          };
                      })
                    : [],
                dealed_at_format: formatUnixTime(one.dealed_at),
                created_at_format: formatUnixTime(one.created_at),
                over_time_name:
                    one.result > 5 ? "--" : i18n.t("ticket.list.distanceOvertime", { value: formatUnixTime(one.over_time, { distance: true }) })
            };
        })
    };
}

export function add(params) {
    return ajax.post("ticket/add", params);
}

export async function update(_ids, params) {
    // params = { agent_id, status, answer }
    const ids = Array.isArray(_ids) ? _ids : [_ids];
    const result = await ajax.post("ticket/update", { ...params, ids });
    store.dispatch("ticket/update");

    return result;
}

export function listType() {
    return ajax.get("ticket/type/list");
}

export function listAgent(params) {
    return ajax.get("ticket/agent/list", params);
}

export function listAgentGroup() {
    return ajax.get("ticket/agent/group/list");
}

export function updateMyStatus(status) {
    return ajax.post("ticket/agent/update", { status });
}

export function getMyStatus() {
    return ajax.get("ticket/agent/me");
}

export function getRobotSession(robot_session_id) {
    return ajax.get("ticket/robot/session/get", { robot_session_id });
}

export function getStatementTypeList(language) {
    language = language == "all" ? "" : language;
    return ajax.get("statement/type/list", { language });
}

export function getStatementSearch(query) {
    query = getQuestionListParams(query);
    return ajax.get("statement/list", { ...query });
}

export function setStatementTop(query) {
    return ajax.post("/statement/top/set", { ...query });
}

export async function record(query = {}) {
    const result = await ajax.get("ticket/operate_record/list", { ...query });
    const { list } = result;
    let ids = [];

    list.forEach(({ operator_id, owner_id }) => {
        ids.push(operator_id);
        ids.push(owner_id);
    });

    ids = Array.from(new Set(ids.map(({ id } = {}) => id).filter(x => x)));

    const [agentMap] = await Promise.all([getMap(listAgent({ ids }))]);

    const eventMap = {
        "1": i18n.t("ticket.record.create"),
        "2": i18n.t("ticket.record.assign"),
        "3": i18n.t("ticket.record.transfer"),
        "4": i18n.t("ticket.record.notes"),
        "5": i18n.t("ticket.record.close"),
        "6": i18n.t("ticket.record.auto")
    };

    const channelMap = {
        "1": "unknown",
        "2": "not user",
        "3": "SVIP",
        "7": i18n.t("zhiji.channel.H5Site"),
        "11": i18n.t("zhiji.channel.H5Scenes"),
        "8": i18n.t("zhiji.channel.SDKSet"),
        "12": i18n.t("zhiji.channel.SDKLogin")
    };

    return list.map(one => {
        return {
            ...one,
            operatorName: one.event == 1 ? channelMap[one.channel] : agentMap[one.operator_id] || "system",
            ownerName: agentMap[one.owner_id] || "--",
            event: eventMap[one.event],
            content: one.content || "--",
            time: formatUnixTime(one.time)
        };
    });
}

export async function mark(query = {}) {
    await ajax.post("ticket/remark/add", { ...query });
}

export async function autoToAgent(query = {}) {
    await ajax.post("ticket/auto_reply_to_manual", { ...query });
}

export async function history(query = {}) {
    return await ajax.get("ticket/user/punish/history", { ...query });
}

export async function vip_level(query = {}) {
    return await ajax.get("ticket/user/vip_level", { ...query });
}

export async function punish_status(query = {}) {
    let { unban_time, status } = await ajax.get("ticket/user/punish/status", { ...query });
    if (status == 2) {
        unban_time = "--";
    }
    return { unban_time, status };
}

export async function translate(query = {}) {
    return await ajax.post("language/translate", { ...query });
}

export async function batch_translate(query = {}) {
    return await ajax.post("language/batch/translate", { ...query });
}

// 参数处理
function getQuestionListParams(query) {
    return {
        ...query,
        language: query.language == "all" ? "" : query.language,
        channels: query.channels == "all" ? "" : query.channels
    };
}
